import { CalendarStarIcon } from './CalendarStarIcon';

/**
 * author: Michael Richins
 * id 96505BCC-D522-45A6-A642-85F1B4248FAA
 * name calendar-star
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-star.svg
 * tags
 * - Date / Time 
 */
export const EventStarIcon = CalendarStarIcon;
export default EventStarIcon